export default "__VITE_ASSET__C_nHz5lC__"